module.exports = __webpack_public_path__ + "static/media/prysmatic-labs-circle.96c803fe.png";